import { render, staticRenderFns } from "./OptionGroupModal.vue?vue&type=template&id=b833ff5c&scoped=true"
import script from "./OptionGroupModal.vue?vue&type=script&lang=js"
export * from "./OptionGroupModal.vue?vue&type=script&lang=js"
import style0 from "./OptionGroupModal.vue?vue&type=style&index=0&id=b833ff5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b833ff5c",
  null
  
)

export default component.exports